import * as React from "react";
import { usePsycheRadarController } from "./Controller/PsycheRadarController";
import { PsycheRadarView } from "./View/PsycheRadarView";

export function PsycheRadar() {
    return <PsycheRadarView controller={usePsycheRadarController()} />;
}
